import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import {updateSeduta} from "../meeting/Utils";
import {properties} from "../../utils/properties";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    List,
    ListItem,
    ListItemText,
    Box,
    Card, 
    CardContent,
    Button,
    Stack,
  } from "@mui/material";
  
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function AuditSeduta() {    
    //const [auditSeduta, setTopicList] = useState([]);
    const [auditSedute, setAuditSedute] = useState([]);
    //const [groupedData,setGroupedData]=useState([]);
    
    const navigate = useNavigate();
   
    const { pageRouter, setPageRouter } = useContext(RouterContext);    
  

  
    const formatData = (str) => {
        const year = str.slice(0, 4);
        const month = str.slice(4, 6);
        const day = str.slice(6, 8);
        return `${day}/${month}/${year}`;
      };
      
      const tipiRiga1 = ["Comitato", "Consiglio", "Collegio"];
      const tipiRiga2 = ["CG_PIANETA", "CG_PERSONE", "CG_CULTURA", "CG_FINANZA"];
      
  /*
    const renderCards = (tipi) =>
      tipi.map((organo) => {
        const eventiFiltrati = auditSedute
          .filter((e) => e.organo === organo)
          .sort((a, b) => b.data_seduta.localeCompare(a.data_seduta));
  
        return (
          <Card key={organo} sx={{ width: 200, height: 250, overflow: 'hidden', m: 1 }}>
            <CardContent>
              <Typography variant="h6">Organo: {organo}</Typography>
              <Box
                sx={{
                  mt: 1,
                  maxHeight: 160,
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                }}
              >
                {eventiFiltrati.map((e, idx) => (
                  <Button key={idx} variant="outlined" fullWidth size="small">
                    {formatData(e.data_seduta)}
                  </Button>
                ))}
              </Box>
            </CardContent>
          </Card>
        );
      });

*/

function convertiLabel(organo) {
    if(organo=="Comitato")
        return "Comitato di Gestione";
    else if(organo=="Collegio")
        return "Collegio Sindacale";
    else if(organo=="Consiglio")
        return "Consiglio Generale";
    else if(organo=="CG_PIANETA")
        return "Commssione Pianeta";
    else if(organo=="CG_CULTURA")
        return "Commssione Cultura";
    else if(organo=="CG_PERSONE")
        return "Commssione Persone";
    else if(organo=="CG_FINANZA")
        return "Commssione Finanza";
    return organo;
}  


const renderCards = (tipi, rowCount) => {
    //const width = `${100 / tipi.length}%`; // distribuzione uniforme
    //const height = `${100 / rowCount}%`;

    return tipi.map((organo) => {
      const eventiFiltrati = auditSedute
        .filter((e) => e.organo === organo)
        .sort((a, b) => b.data_seduta.localeCompare(a.data_seduta));
        
      return (
        
        <Card
          key={organo}
          sx={{
            //width,
            flex:1,
            //height:'100%',
            //maxHeight:"300px",
            minHeight:"200px",
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            p: 1,
            overflow: 'hidden',
            //background: '#F5f5f5',
            minWidth:0
          }}
        >
          <CardContent sx={{ flex: '0 0 auto', p: 1 }}>
            <Typography align="left" sx={{paddingLeft:"10px"}} variant="h6" fontWeight="bold"> {convertiLabel(organo)}</Typography>
          </CardContent>
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              px: 1,
              pb: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            {eventiFiltrati.map((e, idx) => (
              /*  
              <Button key={idx} variant="outlined" fullWidth >
                Seduta del {formatData(e.data_seduta)}
            </Button> */
            <div className="common-list" key={idx} onClick={() => auditArgument(e,idx)}
                style={{ cursor: "pointer",  paddingLeft: "40px", borderStyle:"solid",
                borderColor:"#CCCCCC", borderWidth:"1px"}}>
                
                <p className= "textBlackSedute">Seduta del {formatData(e.data_seduta)}</p>
                <div style={{ color: "#879497", display: "flex", alignItems: "center"}}>
                    <div style={{ paddingRight: "10px", color: "#879497", display: "flex"}}>                                        
                        <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
                    </div>
                    <div style={{ marginLeft: "10px", width: "10px", height: "63px", background: convertiOrganoInColore(e.organo), borderBottomRightRadius: "8px", borderTopRightRadius: "8px"}}>                        
                    </div>
                </div>
            </div>
            ))}
          </Box>
        </Card>
      );
    });
  };


  function convertiOrganoInColore(organo) {
    if(organo=="Comitato")
        return "#30720f";
    else if(organo=="Consiglio")
        return "#BF360C";
    else if(organo=="Collegio")
        return "#666999";
    else if(organo=="CG_PIANETA")
        return "#008FD1";
    else if(organo=="CG_PERSONE")
        return "#F0B323";
    else if(organo=="CG_CULTURA")
        return "#ce0f69";
    else if(organo=="CG_FINANZA")
        return "#046A38";    
    else 
        return "#000000";
}  



  const auditArgument = (e, index) => {
    console.log("AUDIT ARG",e, index);
    navigate("/audit/" + e.organo + "/"+ e.data_seduta);  
    /*
    if (cntCard) {
        var cardType = topicList[index]["cardIds"][0].item_id;
        if (cardType === "../../proposteintervento/") {                
           
            navigate("/fascicoli/" + meetingId + "/"+ valTobeUsed);  
        } else {                
           
            navigate("/fascicoli/" + meetingId + "/"+ valTobeUsed);  
        }
    } else {            
      
    }
    */
};

    const updateUI = function(auditData) {    
        console.log("UPDATEUI",auditData);
        //auditData=aggiornaCoerenza(auditData);
        setAuditSedute(auditData);
        //console.log("UPDATEUI",auditData);
        //setAuditSeduta(auditData);
        //setGroupedData(raggruppaDati(auditData));
        

        
      //const topicList = Object.entries(meetingData)[6][1];
      //const valueTopicList = Object.values(topicList);
      //const keyTopicList = Object.keys(topicList);
      //setTopicList(valueTopicList);
      //setKeyTopicList(keyTopicList);   
    }

    const doPostGetAuditSedute = function() {
        if( properties.verboseLog==1)
            console.log("doing sedute post");
        var xhr2 = new XMLHttpRequest();                
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/getAuditSedute.php',true);

        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    //setAuditSeduta(obj);
                    //if( properties.verboseLog==1)
                    console.log("OK93",obj);        
                    updateUI(obj);  
                    /*if(obj.status==="204" ){                 
                        console.log("OK TOPICLIST 204",xhr2);
                        const MeetingInfo = JSON.parse(localStorage.getItem("meetingContent"));                        
                        updateUI(MeetingInfo);
                    }              
                    else{
                    //status 201
                        if( properties.verboseLog==1){
                            console.log("OK95",obj.date);
                        }
                        console.log("OK TOPICLIST 201",xhr2);

                        try{
                            localStorage.setItem("meetingContent", obj.content);
                            localStorage.setItem("meeting", meetingId);
                            localStorage.setItem("meetingVersion", obj.date);                                                                                                                                                             
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }   
                    
                        const MeetingInfo = JSON.parse(obj.content);
                        updateUI(MeetingInfo);
                    }*/
                } 
                else {
                    console.error("Error 15", xhr2.statusText);          
                    window.alert("Errore recuperando la seduta 9");        
                    navigate("/init",{ replace: true });  
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 25", xhr2.statusText);
        };
    
        //let urlEncodedData = "organo=Comitato" + "&data=20250121";                
        //let urlEncodedData = "organo=Comitato" + "&data=20250220";                
        let urlEncodedData = "";                
    
        //if( properties.verboseLog==1)
            console.log("AUDITSEDUTE",urlEncodedData);
        xhr2.send(urlEncodedData);
}


    useEffect(() => {
        if(!window.cordova){            
        //CHECK AUTHENTICATION
        var xhr = new XMLHttpRequest();                        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/ping.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {      
                    if( properties.verboseLog==1)
                        console.log("OK",xhr);   
                        doPostGetAuditSedute();                                  
                } else {
                    console.error("Error 5", xhr);         
                    localStorage.clear();                               
                    navigate("/login");  
                }
            }
        };
    
        xhr.onerror = function (e) {
          console.error("Error 75", xhr);
          localStorage.clear();          
          navigate("/login");  
        };
             
        let urlEncodedData = null; 
        xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION        
        }
        
        if (window.cordova){
            doPostGetAuditSedute();
        }                
    }, []);


    return (

        <div style={{ background: "#f5f5f5",
            padding: "30px 5%",
            //minHeight: "calc(100vh - 136px)",
            //height:"100vh",
            height: "calc(100vh - 136px)",
            display: "flex",
            flexDirection: "column" }}>

        <Typography variant="h5" align="left" sx={{paddingBottom:"10px", paddingLeft:"10px"}}>
                {"Statistiche di accesso:"}  {"seleziona l'organo e la seduta di interesse per visualizzarne le statistiche"}
        </Typography>
       
        {/** 
         <Box sx={{ p: 2 }}>
      
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                {renderCards(tipiRiga1)}
            </Box>
      
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', mt: 2 }}>
            {renderCards(tipiRiga2)}
            </Box>
         </Box>
       */}
        <Box
            sx={{
                //height: '100vh',
                height:"95%",
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex:0.2,
                gap: 2,
                p: 1,
                boxSizing: 'border-box',
            }}>      
            <Box sx={{ display: 'flex', flex: 1, gap: 1 ,height: '50%', }}>{renderCards(tipiRiga1, 2)}</Box>     
            <Box sx={{ display: 'flex', flex: 1, gap: 1  ,height: '50%',}}>{renderCards(tipiRiga2, 2)}</Box>
        </Box>
         
        </div>
    );
}
